import type { FC } from "react";
import { IoIosClose } from "react-icons/io";
import { useCartonDigitalModal } from "./cartonDigitalModalHooks";
import type { CartonDigitalModalProps } from "./types";

export const CartonDigitalModal: FC<CartonDigitalModalProps> = (props) => {
  const { cartonItems, handleClose } = useCartonDigitalModal(props);

  return (
    <div className="w-full min-h-screen h-screen z-20 bg-black bg-opacity-50 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
      <div className="bg-gray-200 w-[400px] p-4 rounded-md relative max-h-[90%] overflow-y-auto text-sm">
        <div className="absolute right-2 top-2 cursor-pointer bg-white rounded-[50%] p-[1px]">
          <IoIosClose size={40} onClick={handleClose} />
        </div>
        <div className="w-full flex flex-col gap-2">
          <div className="flex items-center">
            <div className="bg-green-500 w-8 h-8"></div>
            <p className="uppercase text-xs ml-2 font-semibold">
              cuotas pagadas
            </p>
          </div>
          <div className="flex items-center">
            <div className="border border-red-500 w-8 h-8"></div>
            <p className="uppercase text-xs ml-2 font-semibold">
              cuotas faltantes
            </p>
          </div>
          <div className="flex items-center">
            <div className="border bg-yellow-500 w-8 h-8"></div>
            <p className="uppercase text-xs ml-2 font-semibold">Valor pico</p>
          </div>
        </div>
        <div className="grid grid-cols-5 gap-2 mt-4">
          {cartonItems.map((item) => (
            <div key={item.numero} className={item.className}>
              <span className="absolute top-0 left-1 text-[10px]">
                {item.numero}
              </span>
              {item.isValorPico ? `R$${item.valorPicoDisplay}` : null}
              {item.isPagado ? <p className="uppercase text-xs">Pagado</p> : null}

              {item.isValorPico || item.isPagado ? null : (
                <span className="opacity-30 font-semibold">
                  R${item.montoPendiente}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
